/*
 * <kw-etrusted-widget> – wraps an <etrusted-widget> (sections/kw-etrusted-widget.liquid) and loads the
 * eTrusted widget script once the widget comes near the viewport. The script renders every
 * <etrusted-widget> on the page, so it is added only once.
 */
if (!customElements.get("kw-etrusted-widget")) {
  const scriptSrc = "https://integrations.etrusted.com/applications/widget.js/v2";

  customElements.define(
    "kw-etrusted-widget",
    class KwEtrustedWidget extends HTMLElement {
      connectedCallback() {
        if (!("IntersectionObserver" in window)) {
          this.loadScript();
          return;
        }
        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.loadScript();
          },
          { rootMargin: "600px 0px" }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      loadScript() {
        this.observer?.disconnect();
        if (document.querySelector(`script[src="${scriptSrc}"]`)) return;
        const script = document.createElement("script");
        script.src = scriptSrc;
        script.async = true;
        document.head.appendChild(script);
      }
    }
  );
}
